import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DeceasedCustomerModalComponent } from './deceased-customer-modal.component';

@NgModule({
  declarations: [DeceasedCustomerModalComponent],
  imports: [CommonModule],
  exports: [DeceasedCustomerModalComponent]
})
export class DeceasedCustomerModalModule {}
